// src/Dashboard/pages/user/Reglements/components/PaymentSuccessBanner.jsx

import React, { useEffect, useState } from "react";
import {
  FaCheckCircle,
  FaSpinner,
  FaTimes,
  FaTimesCircle,
} from "react-icons/fa";

import { verifyPayment } from "../../../../../services/paymentServices";

export default function PaymentSuccessBanner({ sessionId, onVerified }) {
  const [visible, setVisible] = useState(true);
  const [status, setStatus] = useState("checking");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!sessionId) return;

    let cancelled = false;

    const checkPayment = async () => {
      try {
        setStatus("checking");

        const response = await verifyPayment(sessionId);

        if (cancelled) return;

        const success = !!response?.success;

        setStatus(success ? "success" : "error");
        setMessage(
          success
            ? response?.message || "Paiement vérifié avec succès."
            : response?.message || "Erreur lors de la vérification du paiement."
        );

        await onVerified?.(response);
      } catch {
        if (cancelled) return;

        setStatus("error");
        setMessage("Erreur lors de la vérification du paiement.");
      }
    };

    checkPayment();

    return () => {
      cancelled = true;
    };
  }, [sessionId, onVerified]);

  if (!visible || !sessionId) return null;

  const isChecking = status === "checking";
  const isSuccess = status === "success";
  const isError = status === "error";

  return (
    <div
      className={[
        "overflow-hidden rounded-[24px] border shadow-sm",
        isChecking
          ? "border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900"
          : isSuccess
          ? "border-emerald-200 bg-emerald-50 dark:border-emerald-500/20 dark:bg-emerald-500/10"
          : "border-red-200 bg-red-50 dark:border-red-500/20 dark:bg-red-500/10",
      ].join(" ")}
    >
      <div className="flex items-center justify-between gap-3 px-4 py-4 sm:px-5">
        <div className="flex items-center gap-3">
          <span
            className={[
              "inline-flex h-11 w-11 items-center justify-center rounded-2xl",
              isChecking
                ? "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-200"
                : isSuccess
                ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300"
                : "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-300",
            ].join(" ")}
          >
            {isChecking && <FaSpinner className="animate-spin" />}
            {isSuccess && <FaCheckCircle />}
            {isError && <FaTimesCircle />}
          </span>

          <div>
            <p className="font-bold text-slate-900 dark:text-white">
              {isChecking && "Vérification du paiement..."}
              {isSuccess && "Paiement confirmé"}
              {isError && "Vérification du paiement"}
            </p>

            <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
              {isChecking
                ? "Merci pour votre achat. Votre paiement est en cours de vérification."
                : message}
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={() => setVisible(false)}
          className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white/70 text-slate-600 ring-1 ring-slate-200 transition hover:bg-white dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
}